import {createContext, useState} from "react";

export const IdpAdminEventLogContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [idpAdminEventLogs, setIdpAdminEventLogs] = useState([]);

    // Make the context object:
    const idpAdminEventLogContext = {
        idpAdminEventLogs,
        setIdpAdminEventLogs,
    };

    // pass the value in provider and return
    return <IdpAdminEventLogContext.Provider value={idpAdminEventLogContext}>{children}</IdpAdminEventLogContext.Provider>;
}

export const {Consumer} = IdpAdminEventLogContext;
